import { View, Text } from "react-native";
import React, { useEffect } from "react";
import { createStackNavigator } from "@react-navigation/stack";
import Consultation from "../consultation/Consultation";
import { useDispatch, useSelector } from "react-redux";
import { changeHeaderColor } from "../../redux/header/headerAction";
import { useIsFocused } from "@react-navigation/native";
import { lighterBlue } from "../../colors";
import Chat from "../consultation/Chat";
import SelectChildren from "../consultation/SelectChildren";
import TutorialCategories from "../tutorial/TutorialCategories";
import TutorialCategory from "../tutorial/TutorialCategory";
import Tutorial from "../tutorial/Tutorial";
import Tests from "../test/Tests";
import TestDetails from "../test/TestDetails";
import Wallet from "../main/Wallet";
import UserRegister from "../main/UserRegister";
import NewChildGenderChoose from "../main/NewChildGenderChoose";
import AddNewChild from "../main/AddNewChild";
import Home from "../main/Home";
import FaqScreen from "../main/CommonQuestions";
import Support from "../main/Support";
import AboutUs from "../main/AboutUs";
import EditChild from "../main/EditChild";
import ChildrenDetail from "../main/ChildrenDetail";
import SupportTime from "../main/SupportTime";
import ChatSettings from "../main/ChatSettings";
import Notifications from "../main/Notifications";
import NewTutorial from "../main/NewTutorial";

const Stack = createStackNavigator();

export default function HomeNavigator() {
  const main = useSelector((store) => store.main);
  return (
    <Stack.Navigator
      screenOptions={{ headerShown: false, animationEnabled: true }}
      initialRouteName="Home"
    >
      <Stack.Screen name="Home" component={Home} />
      <Stack.Screen name="Wallet" component={Wallet} />
      <Stack.Screen name="UserRegister" component={UserRegister} />
      <Stack.Screen
        name="NewChildGenderChoose"
        component={NewChildGenderChoose}
      />
      <Stack.Screen name="AddNewChild" component={AddNewChild} />
      <Stack.Screen name="Tutorial" component={Tutorial} />
      <Stack.Screen name="CommonQuestions" component={FaqScreen} />
      {main.rtl && <Stack.Screen name="Support" component={Support} />}
      <Stack.Screen name="AboutUs" component={AboutUs} />
      <Stack.Screen name="ChildrenDetail" component={ChildrenDetail} />
      <Stack.Screen name="EditChild" component={EditChild} />
      <Stack.Screen name="SupportTime" component={SupportTime} />
      <Stack.Screen name="ChatSettings" component={ChatSettings} />
      <Stack.Screen name="NewTutorial" component={NewTutorial} />
      <Stack.Screen name="Notifications" component={Notifications} />
    </Stack.Navigator>
  );
}
